import { defineProperty as _defineProperty, inherits as _inherits, createClass as _createClass, objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { FormControl } from './FormControl.js';
import { DROPDOWN_SEARCH_MINIMUM } from '../../../constants/index.js';
import { checkSelectError, autoComplete, rendererProps, translationProps, getFormattedValue, getDefaultOptionValue, getDefaultOptionLabel, selectOnChange, onFocus } from '../ControlHelpers/SelectUtils.js';
import isEqual from 'lodash/isEqual.js';
import { selectControlStyles, selectTheme } from './SelectControl.styles.js';
import { selectComponents } from './SelectComponentWrappers.js';
var _excluded = ["className", "clearable", "forcePlaceholder", "isClearable", "isFloatOutside", "isMulti", "isSearchable", "multi", "options", "placeholder", "placeholderText", "required", "searchable", "stylesOverride"];
var SelectControl = /*#__PURE__*/function (_FormControl) {
  function SelectControl(props) {
    var _this;
    _classCallCheck(this, SelectControl);
    _this = _callSuper(this, SelectControl, [props]);
    _defineProperty(_this, "componentDidMount", function () {
      _this.setValueOverride();
    });
    _defineProperty(_this, "componentDidUpdate", function (prevProps) {
      if (!isEqual(prevProps.dataValue, _this.props.dataValue) || !isEqual(prevProps.options, _this.props.options)) {
        _this.setValueOverride();
      }
      if (prevProps.clearValue !== _this.props.clearValue && _this.props.clearValue) {
        _this.setState({
          value: null
        });
      }
    });
    _defineProperty(_this, "setValueOverride", function () {
      var _ref, _filteredValue$, _this$select;
      var _this$props = _this.props,
        dataValue = _this$props.dataValue,
        isMulti = _this$props.isMulti,
        multi = _this$props.multi,
        options = _this$props.options,
        valueKey = _this$props.valueKey,
        valueProperty = _this$props.valueProperty,
        isLegacyOverride = _this$props.isLegacyOverride;
      var dataValueAlreadySetOrInexistant = _this.state.hasSetDataValue || dataValue === undefined || dataValue === null; // 0 is valid
      var dataValueIsFilledArray = Array.isArray(dataValue) && !(dataValue !== null && dataValue !== void 0 && dataValue.length);
      if (!(options !== null && options !== void 0 && options.length) || dataValueAlreadySetOrInexistant || dataValueIsFilledArray) return;
      var isMultiSelect = multi || isMulti;
      var key = (_ref = valueKey !== null && valueKey !== void 0 ? valueKey : valueProperty) !== null && _ref !== void 0 ? _ref : 'value';
      var filteredValue = options === null || options === void 0 ? void 0 : options.filter(function (option) {
        var _dataValueArray$inclu;
        if (!Array.isArray(dataValue)) return String(option === null || option === void 0 ? void 0 : option[key]) === String(dataValue);
        var dataValueArray = dataValue.map(function (dv) {
          var _dv$key;
          if (!dv || typeof dv === 'string') return dv;
          return (_dv$key = dv[key]) !== null && _dv$key !== void 0 ? _dv$key : String(dv);
        });
        return dataValueArray === null || dataValueArray === void 0 || (_dataValueArray$inclu = dataValueArray.includes) === null || _dataValueArray$inclu === void 0 ? void 0 : _dataValueArray$inclu.call(dataValueArray, option === null || option === void 0 ? void 0 : option[key]);
      });
      var selectedValue = isMultiSelect ? filteredValue : (_filteredValue$ = filteredValue === null || filteredValue === void 0 ? void 0 : filteredValue[0]) !== null && _filteredValue$ !== void 0 ? _filteredValue$ : {};
      _this.setState(_objectSpread2(_objectSpread2({}, _this.state), {}, {
        hasSetDataValue: true,
        value: selectOnChange(selectedValue, _this.props, (_this$select = _this.select) === null || _this$select === void 0 ? void 0 : _this$select.current, isLegacyOverride)
      }));
    });
    _defineProperty(_this, "onChange", function (val, skipValueChange) {
      var _this$select2;
      var _this$props2 = _this.props,
        onChange = _this$props2.onChange,
        isMulti = _this$props2.isMulti,
        multi = _this$props2.multi;
      var skip = typeof skipValueChange === 'boolean' && skipValueChange;
      var value = selectOnChange(val, _this.props, (_this$select2 = _this.select) === null || _this$select2 === void 0 ? void 0 : _this$select2.current, skip);
      var isMultiSelect = isMulti || multi || false;
      _this.setState(_objectSpread2(_objectSpread2({}, _this.state), {}, {
        value: value
      }));
      if (onChange) {
        onChange(value);
      }
      if (!isMultiSelect) {
        _this.setState({
          isMenuOpen: false
        });
      }
    });
    _defineProperty(_this, "onBlur", function () {
      if (typeof _this.props.onBlur === 'function') {
        _this.props.onBlur(_this.state.value);
      }
      _this.checkError();
    });
    _defineProperty(_this, "onFocus", function (e) {
      onFocus(e, _this.props);
    });
    _defineProperty(_this, "displayHiddenInput", function () {
      var name = _this.props.name;

      // Show/Hide input when Select's internal input's render is toggled to maintain functionality.
      if (name || !_this.isSelectDisabled()) {
        return false;
      }
      var value = _this.state.value;
      if (Array.isArray(value)) {
        return !value.length;
      }
      return !value;
    });
    _defineProperty(_this, "handleOnMenuOpen", function () {
      return _this.setState({
        isMenuOpen: true
      });
    });
    _defineProperty(_this, "handleOnMenuClose", function () {
      return _this.setState({
        isMenuOpen: false
      });
    });
    _defineProperty(_this, "handleOnKeyDown", function (event) {
      if (event.key === 'Enter' && !_this.state.isMenuOpen) {
        _this.handleOnMenuOpen();
      }
    });
    _this.state = {
      hasSetDataValue: false,
      value: props.defaultValue,
      isMenuOpen: false
    };
    _this.select = /*#__PURE__*/React.createRef();
    return _this;
  }
  _inherits(SelectControl, _FormControl);
  return _createClass(SelectControl, [{
    key: "isValid",
    value: function isValid() {
      var _this$select$wrapper;
      var input = (_this$select$wrapper = this.select.wrapper) === null || _this$select$wrapper === void 0 ? void 0 : _this$select$wrapper.querySelector('input');
      if (input) {
        return input.validity.valid;
      }
    }
  }, {
    key: "checkError",
    value: function checkError() {
      var _this$select3;
      checkSelectError(this.props, (_this$select3 = this.select) === null || _this$select3 === void 0 ? void 0 : _this$select3.current);
    }
  }, {
    key: "isSelectDisabled",
    value: function isSelectDisabled() {
      var _this$props3 = this.props,
        disabled = _this$props3.disabled,
        isDisabled = _this$props3.isDisabled;
      return disabled || isDisabled || false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props4 = this.props,
        className = _this$props4.className,
        clearable = _this$props4.clearable,
        forcePlaceholder = _this$props4.forcePlaceholder,
        isClearable = _this$props4.isClearable,
        isFloatOutside = _this$props4.isFloatOutside,
        isMulti = _this$props4.isMulti,
        isSearchable = _this$props4.isSearchable,
        multi = _this$props4.multi,
        options = _this$props4.options,
        placeholder = _this$props4.placeholder,
        placeholderText = _this$props4.placeholderText,
        isRequired = _this$props4.required,
        searchable = _this$props4.searchable,
        stylesOverride = _this$props4.stylesOverride,
        props = _objectWithoutProperties(_this$props4, _excluded); // eslint-disable-line no-unused-vars
      var value = this.state.value;
      var autocomplete = autoComplete(props);
      // default clearable is true unless explicitly false
      var isClearableSelect = !(clearable === false || isClearable === false);
      var isMultiSelect = multi || isMulti || false;
      var formattedName = isMultiSelect ? props.name + '[]' : props.name;
      var isSearchableSelect = !(searchable === false || isSearchable === false) && (options === null || options === void 0 ? void 0 : options.length) > DROPDOWN_SEARCH_MINIMUM;
      var placeholderLabel = (!!placeholderText || !!placeholder) && forcePlaceholder ? placeholderText || placeholder : null;
      var classPrefix = "Select-".concat(props.name ? "".concat(props.name) : '');
      var styles = stylesOverride ? stylesOverride() : selectControlStyles({
        isFloatOutside: isFloatOutside,
        isMultiSelect: isMultiSelect,
        value: value
      });
      var Option = function Option(props) {
        return /*#__PURE__*/(
          // eslint-disable-next-line react/prop-types
          React.createElement("div", _extends({
            ref: props.innerRef
          }, props.innerProps, props), /*#__PURE__*/React.createElement(selectComponents.Option, props))
        );
      };
      var components = _objectSpread2(_objectSpread2({}, selectComponents), {}, {
        Option: Option
      });
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Select, _extends({}, props, autocomplete, rendererProps(isMultiSelect, props), translationProps, {
        "aria-labelledby": "".concat(props.name, "-label"),
        className: className !== null && className !== void 0 ? className : classPrefix,
        classNamePrefix: "Select-",
        components: components,
        getOptionLabel: function getOptionLabel(option) {
          return getDefaultOptionLabel(option, _this2.props);
        },
        getOptionValue: function getOptionValue(option) {
          return getDefaultOptionValue(option, _this2.props);
        },
        hideSelectedOptions: false,
        id: classPrefix,
        inputId: "".concat(classPrefix, "-input"),
        instanceId: "".concat(props.name ? "".concat(props.name, "-") : '', "value"),
        isClearable: isClearableSelect,
        isDisabled: this.isSelectDisabled(),
        isMulti: isMultiSelect,
        isSearchable: isSearchableSelect,
        name: formattedName,
        onBlur: this.onBlur,
        onChange: this.onChange,
        onFocus: this.onFocus,
        options: options !== null && options !== void 0 ? options : [],
        placeholder: placeholderLabel,
        ref: this.select,
        removeSelected: true,
        required: isRequired,
        scrollMenuIntoView: false,
        styles: styles,
        theme: selectTheme,
        value: getFormattedValue(value, options, this.props),
        onMenuOpen: this.handleOnMenuOpen,
        onMenuClose: this.handleOnMenuClose,
        menuIsOpen: this.state.isMenuOpen,
        onKeyDown: this.handleOnKeyDown
      })), this.displayHiddenInput() && /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: formattedName,
        id: formattedName,
        required: isRequired,
        tabIndex: "-1",
        value: value === null || value === void 0 ? void 0 : value.value
      }));
    }
  }]);
}(FormControl);
_defineProperty(SelectControl, "propTypes", {
  'data-object-attribute': PropTypes.string,
  'data-object-id': PropTypes.string,
  'data-object-type': PropTypes.string,
  'data-select': PropTypes.string,
  children: PropTypes.any,
  clearable: PropTypes.bool,
  clearValue: PropTypes.bool,
  dataValue: PropTypes.any,
  defaultValue: PropTypes.any,
  // to support legacy default values
  forcePlaceholder: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isMulti: PropTypes.bool,
  joinValues: PropTypes.bool,
  labelKey: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onValueChange: PropTypes.func,
  options: PropTypes.array,
  placeholderText: PropTypes.string,
  scrollContainerId: PropTypes.string,
  stylesOverride: PropTypes.func,
  valueKey: PropTypes.string,
  valueOverride: PropTypes.bool,
  isLegacyOverride: PropTypes.bool
});
_defineProperty(SelectControl, "defaultProps", Object.assign({}, FormControl.defaultProps, {
  placeholderText: '',
  isLegacyOverride: true,
  clearValue: false
}));
SelectControl.displayName = "SelectControl";
export { SelectControl };